<script setup lang="ts">
const { isDesktop } = useDeviceType()
const user = useSupabaseUser()
const { maybeRedirect } = useSeedMigration()

onMounted(() => {
  maybeRedirect()
})

watch(user, () => {
  maybeRedirect()
})
</script>

<template>
  <div>
    <!-- Mobile Layout  -->
    <div v-if="!isDesktop" class="pt-16">
      <MobileHeader>
        <template #subheader><slot name="subheader" /></template>
      </MobileHeader>
      <main class="flex-1 px-4 pb-40 bg-default">
        <slot />
      </main>
      <MobileMenu />
      <div class="fixed bottom-22 right-4"><slot name="button" /></div>
    </div>

    <!-- Desktop Layout  -->
    <div v-else class="min-h-screen">
      <div
        class="fixed top-2 left-2 bottom-2 w-(--sidebar-width) bg-elevated/60 rounded-3xl p-2"
      >
        <SidebarMenu />
      </div>
      <!-- Mobile Menu at the bottom of the screen -->
      <div class="ml-(--sidebar-width) pl-4 flex flex-col">
        <div class="sticky top-0 px-6 z-30 bg-default/60 backdrop-blur-xl">
          <slot name="subheader" />
        </div>
        <main class="p-6 bg-default">
          <slot />
        </main>
      </div>
      <div><slot name="button" /></div>
    </div>
  </div>
</template>
